/**
 * @file index.tsx
 * @copyright 2023 Boston Scientific Corporation
 * ********************************************************************************************************************
 * Copyright © 2023 Boston Scientific Corporation All rights reserved.
 *
 * This file and its contents are a product of Boston Scientific Corporation.  All software distributed by Boston
 * Scientific Neuromodulation is done so under a software license.  This file may not be copied or modified without
 * execution of the appropriate software license agreement with Boston Scientific Neuromodulation or explicit written
 * permission of Boston Scientific Neuromodulation.
 *
 * This file is provided as is, with no warranties of any kind including the warranties of design, merchantability and
 * fitness for a particular purpose, or arising from a course of dealing, usage or trade practice.
 *
 * Boston Scientific Neuromodulation shall have no liability with respect to the infringement of copyrights, trade
 * secrets or any patents by this file or any part thereof.
 *
 * In no event will Boston Scientific Neuromodulation be liable for any lost revenue or profits or other special,
 * indirect and consequential damages, even if Boston Scientific has been advised of the possibility of such damages,
 * as a result of the usage of this file and software for which this file is a part.
 * ********************************************************************************************************************
 *
 */
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider } from "@mui/material";
import theme from "./theme";
import { BrowserRouter, useRoutes } from "react-router-dom";
import { NotFoundComponent } from "./components/notfound/NotFoundComponent";
import { LandingViewController } from "./components/home/LandingViewController";
import { LoginViewController } from "./components/login/controllers/LoginViewController";
import { PasswordViewController } from "./components/login/controllers/PasswordViewController";
import HealthComponent from "./components/health/HealthComponent";


const AppRoutes = () => {
  const routes = useRoutes([
    { path: "/reset/accounts", element: <PasswordViewController /> },
    { path: "/", element: <LoginViewController /> },
    { path: "/qrportal", element: <LandingViewController /> },
    { path: "/health", element: <HealthComponent /> },
    { path: "*", element: <NotFoundComponent /> }

  ]);
  return routes;
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
if(window.self === window.top) {
  root.render(
    <ThemeProvider theme={theme}>
      <>
        <BrowserRouter >
          <AppRoutes />
        </BrowserRouter>
      </>
    </ThemeProvider>
  );
}

reportWebVitals();
